import { useEffect, useState } from 'react';

import { useCurrentUser, useHubspotWidgetStatus } from 'src/store';

const HUBSPOT_KEY = '39616398';

const showWidget = (user) => {
  if (!window.zE) {
    return;
  }

  window.zE('webWidget', 'prefill', {
    name: {
      value: user.name,
    },
    email: {
      value: user.email,
    },
  });
  window.zE('webWidget', 'show');
};

const hideWidget = () => {
  if (!window.zE) {
    return;
  }

  window.zE('webWidget', 'hide');
};

const HubspotSupportWidget = () => {
  const { hubspotWidgetVisible } = useHubspotWidgetStatus();

  const [loaded, setLoaded] = useState(false);
  const currentUser = useCurrentUser();

  // Mount "hubspot" script
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'hs-script-loader';
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `https://js-na1.hs-scripts.com/${HUBSPOT_KEY}.js`;
    script.onload = () => {
      setLoaded(true);
      hideWidget();
    };
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!loaded || !currentUser || !hubspotWidgetVisible) {
      return undefined;
    }

    showWidget(currentUser);

    return () => {
      hideWidget();
    };
  }, [loaded, currentUser, hubspotWidgetVisible]);

  return null;
};

export default HubspotSupportWidget;
